import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.7 13.3H3.3c-.7 0-1.3-.6-1.3-1.3V4c0-.7.6-1.3 1.3-1.3H10c.7 0 1.3.6 1.3 1.3v.7m1.4 8.6c-.8 0-1.4-.6-1.4-1.3V4.7m1.4 8.6c.7 0 1.3-.6 1.3-1.3V6c0-.7-.6-1.3-1.3-1.3h-1.4m-2.6-2H6m-1.3 8h4m-4-5.4h4V8h-4V5.3Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }